import React from 'react';
import type { V2Item } from '../types';

export function V2WelcomeStep({ items }: { items: V2Item[] }) {
  return (
    <div className="text-center py-10 sm:py-8">
      <div className="w-20 h-20 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-6">
        <svg className="w-10 h-10 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 tracking-tight">Forms to Complete</h2>
      <p className="text-lg text-gray-500 mt-4 max-w-sm mx-auto">
        Please review and complete the following {items.length} form{items.length !== 1 ? 's' : ''}.
      </p>
      {/* Numbered badges, not hollow circles: an empty circle beside a label reads
          as a tappable checkbox. Numbers show this is an ordered list of the forms
          ahead, matching the "following N forms" copy above. */}
      <div className="mt-8 space-y-2.5 max-w-xs mx-auto text-left">
        {items.map((item, i) => (
          <div key={item.instanceItemId} className="flex items-center gap-3 rounded-2xl bg-gray-50 px-4 py-3">
            <div className="w-6 h-6 rounded-full bg-primary-deep/10 text-primary-deep text-xs font-bold flex items-center justify-center shrink-0">
              {i + 1}
            </div>
            <span className="min-w-0 break-words text-sm font-semibold text-gray-800">{item.name}</span>
          </div>
        ))}
      </div>
      <p className="text-xs text-gray-500 mt-8 max-w-xs mx-auto">
        Your answers are saved as you go, so you can pick up where you left off.
      </p>
    </div>
  );
}
